import {ResponseSerialize} from '@simpli/serialized-request'
import {IResource} from '@simpli/resource-collection/dist/types/IResource'
import {GithubRepository} from './GithubRepository'

export class GithubRepositoryLanguage implements IResource {
  idGithubRepositoryLanguagePk: number = 0

  @ResponseSerialize(GithubRepository)
  githubRepository: GithubRepository | null = null

  language: string | null = null
  amountInBytes: number | null = null
  createdAt: Date | null = null
  updatedAt: Date | null = null

  get $id() {
    return 0
  }

  set $id(val) {
    // do nothing
  }

  get $tag() {
    return String(0)
  }
}
